import { render, staticRenderFns } from "./TopicInfo.vue?vue&type=template&id=62e93af4&"
import script from "./TopicInfo.vue?vue&type=script&lang=js&"
export * from "./TopicInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports